const features = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '支持1080P超清播放，自动匹配最佳清晰度，让每一帧都清晰动人。苹果视频与榴莲视频同款画质标准。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '采用智能CDN加速与P2P传输技术，视频秒开零等待，拒绝缓冲卡顿，流畅观影体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美适配iOS、Android手机及平板设备，Web网页版即开即看，随时随地享受影视盛宴。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无弹窗广告干扰，无恶意跳转，纯净观影环境。数据加密传输，保护您的隐私安全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-star-line"></i>
            <span className="whitespace-nowrap">为什么选择我们</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">平台特色</h2>
          <p className="mt-2 text-sm text-foreground-500">四大核心优势，打造极致的手机看片体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}